module.exports = __webpack_public_path__ + "img/Particules_droite.36674e3f.svg";